// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Attachment: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 24" enableBackground="new 0 0 42 24" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M33.5,0.58H11.62c-6.33,0-11.46,5.12-11.46,11.46S5.29,23.5,11.62,23.5h19.79
	v-4.17H11.62c-4.02,0-7.29-3.27-7.29-7.29s3.27-7.29,7.29-7.29H33.5c2.29,0,4.17,1.88,4.17,4.17s-1.88,4.17-4.17,4.17H15.6
	c-1.15,0-1.15-2.08,0-2.08h15.81V6.83H15.79c-2.88,0-5.21,2.33-5.21,5.21s2.33,5.21,5.21,5.21H33.5c4.6,0,8.33-3.73,8.33-8.33
	S38.1,0.58,33.5,0.58z"/>
</svg>;
};

export default React.memo(Attachment);
